import React from 'react';
import { createRoot } from 'react-dom/client';
import TikTok from './TikTok';

document.addEventListener('turbo:load', () => {
  const root = createRoot(
    document.body.appendChild(document.createElement('div'))
  );
  root.render(<TikTok />);
});